import { redemptionOtpChannelsMessage } from "./redemptionOtpChannelsMessage.js";

export const OTP_DELIVERY = {
  IDLE: "idle",
  SENDING: "sending",
  SENT: "sent",
  ERROR: "error",
};

export function otpStepStatusMessage(deliveryState, channels, apiMessage) {
  switch (deliveryState) {
    case OTP_DELIVERY.SENDING:
      return "Sending code…";
    case OTP_DELIVERY.SENT:
      return redemptionOtpChannelsMessage(channels, apiMessage);
    case OTP_DELIVERY.ERROR:
      return apiMessage || "Could not send verification code.";
    default:
      return "";
  }
}
